
import type { Step } from '../types/step';

export const steps: Step[] = [
  {
    id: 1,
    title: 'Мой профессиональный путь',
    description: 'Оглянись на свой путь. Вспомни, как ты росла, менялась, становилась сильнее.',
    questions: [
      { id: 1, text: 'С чего ты начинала?', inputType: 'textarea' },
      { id: 2, text: 'Где было особенно сложно?', inputType: 'textarea' },
      { id: 3, text: 'В какой момент ты поняла, что выросла?', inputType: 'textarea' },
      { id: 4, text: 'Чем ты сейчас гордишься?', inputType: 'textarea' }
    ],
    isUnlocked: true,
    isDone: false,
    reward: 'Ты увидела свой путь. Это уже сила.'
  },
  {
    id: 2,
    title: 'Чем я реально ценна',
    description: 'Твоя ценность — не в должности. Она в том, что ты даёшь людям и делу.',
    questions: [
      { id: 1, text: 'За что тебе чаще всего благодарны?', inputType: 'textarea' },
      { id: 2, text: 'В чём твоя реальная польза для команды?', inputType: 'textarea' },
      { id: 3, text: 'Что ты умеешь делать лучше многих?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты знаешь свою ценность. Это основа уверенности.'
  },
  {
    id: 3,
    title: 'Мой стиль управления',
    description: 'У тебя есть свой стиль. Он не должен быть как у всех — он должен быть твоим.',
    questions: [
      { id: 1, text: 'Как ты принимаешь решения?', inputType: 'textarea' },
      { id: 2, text: 'Как ты реагируешь на хаос?', inputType: 'textarea' },
      { id: 3, text: 'Как ты ведёшь людей?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Твой стиль — это твоя сила. Не копируй других.'
  },
  {
    id: 4,
    title: 'Что я больше не терплю',
    description: 'Границы — это не жёсткость. Это забота о себе и о качестве твоей жизни.',
    questions: [
      { id: 1, text: 'Что ты больше не готова принимать?', inputType: 'textarea' },
      { id: 2, text: 'Где ты больше не молчишь?', inputType: 'textarea' },
      { id: 3, text: 'Какие границы для тебя важны?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты назвала свои границы. Это акт силы.'
  },
  {
    id: 5,
    title: 'Где я молодец',
    description: 'Мы часто не замечаем, где мы справились. Пора это увидеть.',
    questions: [
      { id: 1, text: 'Назови 3 ситуации, где ты справилась', inputType: 'textarea' },
      { id: 2, text: 'Где ты была сильной, даже если не заметила этого сразу', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты увидела свою силу. Она всегда была с тобой.'
  },
  {
    id: 6,
    title: 'Моя энергия',
    description: 'Энергия — это ресурс. Важно знать, что тебя наполняет, а что истощает.',
    questions: [
      { id: 1, text: 'Что тебя наполняет?', inputType: 'textarea' },
      { id: 2, text: 'Что тебя истощает?', inputType: 'textarea' },
      { id: 3, text: 'Что ты хочешь беречь?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты знаешь свою энергию. Береги её.'
  },
  {
    id: 7,
    title: 'Мой голос',
    description: 'Твой голос имеет право звучать. Ты имеешь право говорить «нет».',
    questions: [
      { id: 1, text: 'Как ты говоришь «нет» сейчас?', inputType: 'textarea' },
      { id: 2, text: 'Как ты хочешь говорить «нет»?', inputType: 'textarea' },
      { id: 3, text: 'Как ты хочешь, чтобы с тобой разговаривали?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Твой голос важен. Ты имеешь право быть услышанной.'
  },
  {
    id: 8,
    title: 'Моя уверенность',
    description: 'Уверенность — это не отсутствие сомнений. Это умение действовать, несмотря на них.',
    questions: [
      { id: 1, text: 'В чём ты уверена?', inputType: 'textarea' },
      { id: 2, text: 'Где ты сомневаешься?', inputType: 'textarea' },
      { id: 3, text: 'Что могло бы усилить твою уверенность?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Уверенность растёт из честности с собой.'
  },
  {
    id: 9,
    title: 'Моя ценность для мира',
    description: 'Ты меняешь мир вокруг себя. Каждый день. Даже если не замечаешь этого.',
    questions: [
      { id: 1, text: 'Кому ты помогаешь?', inputType: 'textarea' },
      { id: 2, text: 'Как ты меняешь пространство вокруг себя?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Твоё влияние реально. Ты важна.'
  },
  {
    id: 10,
    title: 'Мои роли',
    description: 'Ты играешь много ролей. Какие из них тебя наполняют, а какие — истощают?',
    questions: [
      { id: 1, text: 'Какие роли ты играешь?', inputType: 'textarea' },
      { id: 2, text: 'Какая роль утомляет?', inputType: 'textarea' },
      { id: 3, text: 'Какая наполняет?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты видишь свои роли. Теперь ты можешь выбирать.'
  },
  {
    id: 11,
    title: 'Мои желания',
    description: 'Твои желания важны. Они показывают направление.',
    questions: [
      { id: 1, text: 'Чего ты хочешь больше?', inputType: 'textarea' },
      { id: 2, text: 'Чего ты хочешь меньше?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты знаешь, чего хочешь. Это уже половина пути.'
  },
  {
    id: 12,
    title: 'Мои ресурсы',
    description: 'У тебя есть опора. Важно её видеть и использовать.',
    questions: [
      { id: 1, text: 'На что ты можешь опереться?', inputType: 'textarea' },
      { id: 2, text: 'Кто твоя поддержка?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты не одна. У тебя есть ресурсы.'
  },
  {
    id: 13,
    title: 'Моё будущее',
    description: 'Будущее начинается с того, как ты его представляешь.',
    questions: [
      { id: 1, text: 'Где ты через год?', inputType: 'textarea' },
      { id: 2, text: 'Как ты хочешь жить?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты видишь своё будущее. Оно уже начинается.'
  },
  {
    id: 14,
    title: 'Мои правила',
    description: 'Твои правила — это твоя система координат. Они помогают тебе не сбиться с пути.',
    questions: [
      { id: 1, text: 'Какие 3 правила ты хочешь для себя?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты создала свои правила. Теперь ты знаешь, как жить.'
  },
  {
    id: 15,
    title: 'Манифест',
    description: 'Это финал. Здесь ты собираешь всё воедино и создаёшь свой профессиональный манифест.',
    questions: [
      { id: 1, text: 'Кто ты?', inputType: 'textarea' },
      { id: 2, text: 'Как ты выбираешь жить и работать?', inputType: 'textarea' },
      { id: 3, text: 'В чём твоя сила?', inputType: 'textarea' }
    ],
    isUnlocked: false,
    isDone: false,
    reward: 'Ты прошла весь путь. Теперь у тебя есть твой манифест.'
  }
];
